<template>
  <div>
    <el-card shadow="never" :body-style="{padding: '10px'}">
      <div class="G_Field">
        <div class="Label c_link" style="text-align: center">
          省份：
        </div>
        <div class="Fields">
          <div class="row" v-if="province">
            <a class="city_link active">{{p_name}}</a>
            <el-button round size="mini" @click="province=!province"> + 更多省份</el-button>
          </div>
          <div class="row" v-if="!province">
          <a @click="getCity('all'), c_name='全部', city_list={},childClick()" class="city_link" :class="cid == 'all' ? 'active':''">全部</a>
          <a v-for="item of province_list" :key="item.id" @click="cityall = 'all', p_name=item.name, c_name='全部', city_list={}, city=false,pclick(item.code)" :class="item.code == cid || p_name == item.name ? 'active':''" class="city_link">
            {{item.name}}</a>
          <div class="p-0" style="text-align: left">
            <el-button round size="mini" @click="province=!province"> - 收起</el-button>
          </div>
          </div>
        </div>
        </div>
    </el-card>
    <el-card shadow="never" :body-style="{padding: '10px'}">
      <div class="G_Field">
        <div class="Label c_link" style="text-align: center">
          城市：
        </div>
        <div class="Fields">
          <div class="row" v-if="city">
            <a class="city_link active">{{c_name}}</a>
            <el-button round size="mini" @click="city=!city"> + 更多城市</el-button>
          </div>
          <div class="row" v-if="!city">
            <a @click="CityAllClick(),city=true, c_name='全部',childClick()" class="city_link" :class="String(this.$route.query.cid / 10000).length === 2 || cid == 'all' ? 'active':''">全部</a>
            <a v-for="item of city_list" :key="item.id" @click="$route.query.cid='', cid = item.code, c_name=item.name, city=!city, cityall='',childClick()" :class="item.code == $route.query.cid || cid == 'all' ? 'active':''" class="city_link">
              {{item.name}}</a>
            <div class="p-0" style="text-align: left">
              <el-button round size="mini" @click="city=!city"> - 收起</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {request} from '../../network/request'
export default {
  name: 'ListCity',
  data () {
    return {
      province: true,
      city: true,
      province_list: {},
      city_list: {},
      cid: 0,
      p_name: '全部',
      c_name: '全部'
    }
  },
  props: {
    cityname: {
      type: String
    },
    provincename: {
      type: String
    }
  },
  watch: {
    '$route': {
      handler (newVal) {
        // 如果有值
        if (this.$route.query.cid !== 'all' && this.$route.query.cid) {
          let data = new URLSearchParams()
          data.append('cid', this.$route.query.cid)
          request({
            url: '/api/cityname',
            method: 'post',
            data: data
          }).then(res => {
            if (String(this.$route.query.cid / 10000).length === 2) {
              this.c_name = '全部'
            } else {
              this.c_name = res.data.city
            }
            this.p_name = res.data.province
          }).catch(err => {
            console.log(err)
          })
          if (this.$route.query.cid) {
            let pid = parseInt(this.$route.query.cid / 10000) * 10000
            this.getCity(pid)
          }
        } else {
          this.cid = 'all'
          this.c_name = '全部'
          this.p_name = '全部'
          this.city_list = {}
        }
      }
    }
  },
  mounted () {
    this.getProvince()
    if (this.cityname) {
      this.c_name = this.cityname
    }
    if (this.provincename) {
      this.p_name = this.provincename
    }
    if (this.$route.query.cid && this.$route.query.cid !== 'all') {
      let pid = parseInt(this.$route.query.cid / 10000) * 10000
      this.getCity(pid)
    } else {
      this.cid = 'all'
    }
  },
  methods: {
    CityAllClick () {
      if (this.cid === 'all') {
      } else {
        this.cid = parseInt(this.cid / 10000) * 10000
        this.c_name = '全部'
      }
    },
    pclick (code) {
      this.$router.push({
        path: this.$route.path,
        query: {
          cid: code,
          t: this.$route.query.t
        }
      })
    },
    childClick () {
      this.$router.push({
        path: this.$route.path,
        query: {
          cid: this.cid,
          t: this.$route.query.t
        }
      })
    },
    // 获取省级列表
    getProvince () {
      request({
        url: '/api/province',
        method: 'post'
      }).then(res => {
        this.province_list = res.data
      }).catch(err => {
        console.log(err)
      })
    },
    getCity (code) {
      this.province = true
      if (code === 'all') {
        this.p_name = '全部'
        this.cid = 'all'
      } else {
        this.cid = code
        let data = new URLSearchParams()
        data.append('provinceId', code)
        request({
          url: '/api/selectCity',
          method: 'post',
          data: data
        }).then(res => {
          this.city_list = res.data.citylists
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style scoped>
  .G_Field {
    display: flex!important;
    border-radius: .25rem!important;
    padding-top: .5rem;
    padding-bottom: .5rem;
  }
  .p-0{
    padding: 0!important;
    margin-bottom: .5rem!important;
    margin-top: .5rem!important;
    flex: 0 0 100%;
    max-width: 100%;
    position: relative;
    width: 100%;
  }
  .city_link {
    font-size: 14px;
    word-break: keep-all;
    color: #666;
    text-decoration: none;
    padding-top: 5px;
    padding-bottom: 5px;
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
  @media (min-width: 576px){
    .city_link {
      flex: 0 0 25%;
      max-width: 25%;
    }
  }
  @media (min-width: 768px){
    .city_link {
      flex: 0 0 16.66667%;
      max-width: 16.66667%;
    }
  }
  @media (min-width: 992px){
    .city_link {
      flex: 0 0 10%;
      max-width: 10%;
    }
  }
  .c_link{
    font-size: 14px;
    word-break: keep-all;
    color: #666;
    text-decoration: none;
    margin: 5px;
    width: 99px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
  @media (max-width: 768px) {
    .hot_link {
      width: 70px;
    }
  }

  .Label {
    font-weight: 700!important;
  }

  .Fields {
    flex: 1 1;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .active {
    color: #f39;
  }
  .row{
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/widget/listcity.vue